"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderTransformer = void 0;

var lodash_isundefined_1 = __importDefault(require("lodash.isundefined"));

var lodash_isfunction_1 = __importDefault(require("lodash.isfunction"));

var lodash_uniq_1 = __importDefault(require("lodash.uniq"));

var lodash_groupby_1 = __importDefault(require("lodash.groupby"));

var HeaderTransformer = /*#__PURE__*/function () {
  function HeaderTransformer(parserOptions) {
    _classCallCheck(this, HeaderTransformer);

    this.headers = null;
    this.receivedHeaders = false;
    this.shouldUseFirstRow = false;
    this.processedFirstRow = false;
    this.headersLength = 0;
    this.parserOptions = parserOptions;

    if (parserOptions.headers === true) {
      this.shouldUseFirstRow = true;
    } else if (Array.isArray(parserOptions.headers)) {
      this.setHeaders(parserOptions.headers);
    } else if (lodash_isfunction_1.default(parserOptions.headers)) {
      this.headersTransform = parserOptions.headers;
    }
  }

  _createClass(HeaderTransformer, [{
    key: "transform",
    value: function transform(row, cb) {
      if (!this.shouldMapRow(row)) {
        return cb(null, {
          row: null,
          isValid: true
        });
      }

      return cb(null, this.processRow(row));
    }
  }, {
    key: "shouldMapRow",
    value: function shouldMapRow(row) {
      var parserOptions = this.parserOptions;

      if (!this.headersTransform && parserOptions.renameHeaders && !this.processedFirstRow) {
        if (!this.receivedHeaders) {
          throw new Error('Error renaming headers: new headers must be provided in an array');
        }

        this.processedFirstRow = true;
        return false;
      }

      if (!this.receivedHeaders && Array.isArray(row)) {
        if (this.headersTransform) {
          this.setHeaders(this.headersTransform(row));
        } else if (this.shouldUseFirstRow) {
          this.setHeaders(row);
        } else {
          // dont do anything with the headers if we didnt receive a transform or shouldnt use the first row.
          return true;
        }

        return false;
      }

      return true;
    }
  }, {
    key: "processRow",
    value: function processRow(row) {
      if (!this.headers) {
        return {
          row: row,
          isValid: true
        };
      }

      var parserOptions = this.parserOptions;

      if (!parserOptions.discardUnmappedColumns && row.length > this.headersLength) {
        if (!parserOptions.strictColumnHandling) {
          throw new Error("Unexpected Error: column header mismatch expected: ".concat(this.headersLength, " columns got: ").concat(row.length));
        }

        return {
          row: row,
          isValid: false,
          reason: "Column header mismatch expected: ".concat(this.headersLength, " columns got: ").concat(row.length)
        };
      }

      if (parserOptions.strictColumnHandling && row.length < this.headersLength) {
        return {
          row: row,
          isValid: false,
          reason: "Column header mismatch expected: ".concat(this.headersLength, " columns got: ").concat(row.length)
        };
      }

      return {
        row: this.mapHeaders(row),
        isValid: true
      };
    }
  }, {
    key: "mapHeaders",
    value: function mapHeaders(row) {
      var rowMap = {};
      var headers = this.headers,
          headersLength = this.headersLength;

      for (var i = 0; i < headersLength; i += 1) {
        var header = headers[i];

        if (!lodash_isundefined_1.default(header)) {
          var val = row[i]; // eslint-disable-next-line no-param-reassign

          if (lodash_isundefined_1.default(val)) {
            rowMap[header] = '';
          } else {
            rowMap[header] = val;
          }
        }
      }

      return rowMap;
    }
  }, {
    key: "setHeaders",
    value: function setHeaders(headers) {
      var _a;

      var filteredHeaders = headers.filter(function (h) {
        return !!h;
      });

      if (lodash_uniq_1.default(filteredHeaders).length !== filteredHeaders.length) {
        var grouped = lodash_groupby_1.default(filteredHeaders);
        var duplicates = Object.keys(grouped).filter(function (dup) {
          return grouped[dup].length > 1;
        });
        throw new Error("Duplicate headers found ".concat(JSON.stringify(duplicates)));
      }

      this.headers = headers;
      this.receivedHeaders = true;
      this.headersLength = ((_a = this.headers) === null || _a === void 0 ? void 0 : _a.length) || 0;
    }
  }]);

  return HeaderTransformer;
}();

exports.HeaderTransformer = HeaderTransformer;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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